import { showCartErrorMessage } from 'features/cart/desktop';
import { formToJSON } from 'utilities/form';
import { initBlockEnterKeyForDisabledButton, setButtonStateDuringActivity } from 'utilities/dom';
import { trackCartActions } from 'features/cart';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import { cart, cartModel, widgetValidationOptions } from '../config';
import CartBaseItemView from '../../baseViews/ItemView';
import { GetCartContentForPrint, GetCartContentForPrintInStore } from '../../api';
import printCartContent from '../printCartContent';

const PrintOptionsModal = CartBaseItemView.extend({
	template: false, // no template, HTML already in the DOM
	ui: {
		printCartBtn: '.printCartBtn',
		printStyleOptions: '.printStyleOptions',
		printCartOptions: '.printCartOptions',
		printCartOptionForm: '#printCartOptionForm',
		selectAllOrNone: '.selectAllOrNone',
		showPricesSubOptions: '.showPricesSubOptions',
		checkboxes: '#printCartOptionForm input[type="checkbox"]',
		showPrices: '#showPrices',
		printCartOptionBtn: '#printCartOptionBtn',
		printInStoreOptionBtn: '#printInStoreOptionBtn',
		printOptionsContainer: '#printOptionsContainer',
		printOutputContainer: '#printOutputContainer',
		printOutput: '#printOutput',
		printContentBtn: '.printContentBtn',
		extraOptions: '.extraOptions',
		imageSizeOption: '.imageSizeOption',
		roomScenesOption: '.roomScenesOption',
		showBulbsOption: '#showBulbs'
	},
	events: {
		'click @ui.selectAllOrNone': 'toggleSelect',
		'click @ui.showPrices': 'showPricesSubOptions',
		'click @ui.printCartBtn': 'printCart',
		'click @ui.printContentBtn': 'prePrintCartContent',
		'click @ui.printCartOptionBtn': 'showPrintCartOptions',
		'click @ui.printInStoreOptionBtn': 'printInStore',
		'click @ui.imageSizeOption': 'showSceneOption'
	},
	initialize () {

		this.bindUIElements(); // bind UI to the elements already in the DOM

		if (
			window.lp.globals.isStoreInSession
			&& _.findWhere(cartModel.get('ProductItems'), { IsPickUpInStore: true })
		) {

			this.showKioskPrintOptions();

		} else {

			this.showPrintOptions();

		}

	},
	onRender () {

		initBlockEnterKeyForDisabledButton(this.ui.printCartBtn[0]);

	},
	showPrintCartOptions (e) {

		e.preventDefault();
		$('body').lpModalResize({
			height: 585,
			width: 756
		});
		this.showPrintOptions.call(this, e, true);

	},
	showPrintOptions (e, showExtraOptions) {

		const that = this;

		if (e) {

			e.preventDefault();

		}

		// reset form
		this.ui.printCartOptionForm.trigger('reset');

		// needs delay due to form reset timing
		setTimeout(() => {

			if (showExtraOptions) {

				that.ui.extraOptions.removeClass('hidden').find('input').prop('checked', true);

			} else {

				that.ui.extraOptions.addClass('hidden').find('input').prop('checked', false);

			}
			that.ui.printStyleOptions.addClass('hidden');
			that.ui.printCartOptions.removeClass('hidden');

			$('#showPrices,.imageSizeOption').filter(':checked').prop('checked', false).trigger('click');

		}, 0);

	},
	showKioskPrintOptions () {

		const that = this;
		const validationOptions = {
			onclick (element) {

				$(element.form).valid();

			}
		};

		this.ui.printStyleOptions.removeClass('hidden');
		this.ui.printCartOptions.addClass('hidden');

		$.validator.addMethod(
			'checkboxesCheckedAtLeastOne',
			() => that.ui.extraOptions.find('input:checked').length > 0,
			'Please select Show In-Store and/or Show Ship.'
		);

		window.initFormValidation(
			true,
			this.ui.printCartOptionForm,
			$.extend({}, widgetValidationOptions, validationOptions)
		);

		this.ui.extraOptions.find('input').each(function () {

			$(this).rules('add', { checkboxesCheckedAtLeastOne: true });

		});

	},
	toggleSelect (e) {

		e.preventDefault();
		if ($(e.target).data('select') === 'all') {

			this.ui.checkboxes.prop('checked', true);
			this.ui.showPricesSubOptions.fadeIn('slow');

		} else {

			this.ui.checkboxes.prop('checked', false);
			this.ui.showPricesSubOptions.fadeOut('slow');

		}
		this.ui.printCartOptionForm.valid();

	},
	showPricesSubOptions (e) {

		if (e.target.checked) {

			$('input', this.ui.showPricesSubOptions).prop('checked', true);
			this.ui.showPricesSubOptions.fadeIn('slow');

		} else {

			$('input', this.ui.showPricesSubOptions).prop('checked', false);
			this.ui.showPricesSubOptions.fadeOut('slow');

		}

	},
	showSceneOption (e) {

		this.ui.roomScenesOption[$(e.target).attr('id') === 'rdoLargeImages' ? 'removeClass' : 'addClass']('hidden');

	},
	printCart () {

		const that = this;
		let printCartOption;
		const hasExtraOptions = this.ui.extraOptions.is(':visible');
		// validation only occurs if Ship/In-Store options are available
		const formValid = hasExtraOptions ? this.ui.printCartOptionForm.valid() : true;

		if (formValid) {

			printCartOption = formToJSON(this.ui.printCartOptionForm[0]);

			if (hasExtraOptions) {

				// need to pass false explicitly if not checked
				printCartOption.ShowInStore = printCartOption.ShowInStore || false;
				printCartOption.ShowShip = printCartOption.ShowShip || false;

			}

			const request = GetCartContentForPrint(printCartOption).then((response) => {

				if (response.IsSuccess) {

					that.ui.printOptionsContainer.addClass('hidden');
					that.ui.printOutputContainer.removeClass('hidden inStore');
					that.ui.printOutput.html(response.GlobalCartResponseModel);

				} else {

					showCartErrorMessage({
						response,
						fromModal: true
					});

				}

			});
			setButtonStateDuringActivity(this.ui.printCartBtn[0], request);
			$(cart).trigger('indicateLoad', request);

		}

	},
	printInStore (e) {

		const that = this;
		e.preventDefault();

		const request = GetCartContentForPrintInStore().then((response) => {

			if (response.operationSuccess) {

				that.ui.printOptionsContainer.addClass('hidden');
				that.ui.printOutputContainer.removeClass('hidden').addClass('inStore');
				that.ui.printOutput.html(response.GlobalCartResponseModel);

			} else {

				showCartErrorMessage({
					response,
					fromModal: true
				});

			}

		});
		$(cart).trigger('indicateLoad', request);

	},
	prePrintCartContent (e) {

		trackCartActions({
			event_action: 'Click-Employee-Print-Confirm'
		});

		setGenericEvent({ event_name: 'cart_print_confirm' });

		printCartContent(e);

	}
});

export default PrintOptionsModal;
